import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

// Legacy URLs from the previous WordPress site. When crawled or clicked, they must
// resolve to the homepage. True HTTP 301 requires ingress config on the deploy
// platform; this component provides the client-side equivalent (URL rewrite +
// canonical + <meta refresh> for non-JS crawlers).
// NOTE: `/music` is a real live route as of Stage 2 (catalog SSR), so it has
// been removed from this list. It maps to <MusicHub/> in App.js.
const LEGACY_PATHS = [
    "/biography",
    "/biography/",
    "/videos",
    "/videos/",
    "/gallery",
    "/gallery/",
    "/events",
    "/events/",
    "/contact",
    "/contact/",
];

export default function LegacyRedirect() {
    const location = useLocation();
    useEffect(() => {
        // Rewrite the URL bar to "/" without adding a history entry
        try {
            window.history.replaceState(null, "", "/");
        } catch { /* noop */ }
    }, [location.pathname]);
    return <Navigate to="/" replace />;
}

export { LEGACY_PATHS };
